import FavoriteList from "../components/wishList/FavoriteList";

const WishList = () => {
  return (
    <div className="favorite-page">
      <FavoriteList />
    </div>
  );
};
export default WishList;
